"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
const cc = (0, react_icons_1.IWrapperFull)();
const names = Object.keys(cc);
function IconSel(props) {
    const { onChange, sel, className, disabled } = props;
    const [cur, setCur] = (0, react_1.useState)(sel || null);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)('');
    const filtered = (0, react_1.useMemo)(() => {
        return names.filter((e) => search === '' || e.toLowerCase().includes(search.toLowerCase()));
    }, [search]);
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-flex-r', className) },
        react_1.default.createElement("div", { style: { position: 'relative' } },
            cur
                ? (0, react_icons_1.getIcon)(cur)({
                    size: react_icons_1.ISize.SM,
                })
                : 'none',
            open && !disabled ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("input", { type: "text", placeholder: "Search...", value: search, onChange: (e) => setSearch(e.target.value) })),
                react_1.default.createElement("div", { className: "glx-icon-sel--dropdown" },
                    react_1.default.createElement("div", { key: "none", onClick: () => {
                            setOpen(false);
                            setCur(null);
                            onChange(null);
                            setSearch('');
                        } }, "N/D"),
                    filtered.map((el) => (react_1.default.createElement("div", { key: el, role: "button", onClick: () => {
                            setOpen(false);
                            setCur(el);
                            onChange(el);
                            setSearch('');
                        } }, (0, react_icons_1.getIcon)(el)({ size: react_icons_1.ISize.SM }))))))) : null),
        react_1.default.createElement("div", { onClick: () => {
                setOpen(!open);
                if (sel) {
                    setSearch(sel);
                }
            } },
            react_1.default.createElement(react_icons_1.IOChevronDown, null))));
}
exports.default = IconSel;
IconSel.defaultProps = {
    className: undefined,
    disabled: false,
    sel: undefined,
};
